import { getIdPortenToken, idPorten, nibioToken } from './request/authentication';
import { info, warn } from './notify';
import { moveTo } from './wizard';

const ws = '/klimagasskalkulator_ws';

const order = {
  PRIVATFORETAK: 1, KOMMUNE: 2, FYLKE: 3, STAT: 4, FRIVILLIGORG: 5, ANNET: 6
};

const byType = (t1, t2) => order[t1.id] - order[t2.id];

classifyUserBtn.onclick = () => {
  fRole.setCustomValidity(fRole.value ? '' : 'Registrer en rolle som bruker');
};

export const classifyUser = (e) => {
  // console.log('Classify user:', fRole.value);
  e.preventDefault();
  getIdPortenToken().then(t => {
    const request = new Request(`${ws}/user/setType?usertype=${fRole.value}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json', nibiotoken: t })
    });
    idPorten(
      request,
      response => console.log('Brukeren ble klassifisert'),
      response => console.log('Brukeren ble ikke klassifisert'),
      response => moveTo('home')
      // undefined
    );
  }).catch(err => console.log('catch', err));
};

export const fetchAvailableRoles = () => {
  fetch(`${ws}/user/types`).then(r => r.json()).then(roles => {
    roles.sort(byType).forEach(role => {
      const o = document.createElement('option');
      o.value = role.id;
      o.innerHTML = role.name;
      fRole.appendChild(o);
    });
  });
};

export const getUser = () => nibioToken.user;

const setUserName = (name) => {
  loggedInUserName.innerHTML = name;
  logoutBtn.title = `Logg ut (${name})`;
  profileBtn.title = `Min side (${name})`;
};

export const fillProfileIn = (_user) => {
  // console.log(_user);
  setUserName(_user.name || _user.email);
  if (!_user.userType) {
    fetchAvailableRoles();
    moveTo('user');
  }
};

export const goToMinSide = (autoComeBack) => {
  const srvMinSide = `https://${import.meta.env.VITE_MINSIDE}`;
  const p = new URLSearchParams(`opprinnelse=${window.location.href}`);
  p.set('token', sessionStorage.getItem('nibioToken'));
  if (autoComeBack) p.set('tilbake', autoComeBack);
  const minside = `${srvMinSide}?${p.toString()}`;
  window.location.href = minside;
};
